import { useContext } from 'react'
import { ButlerContext } from './ButlerProvider'

export function useButler() {
  const butlerContext = useContext(ButlerContext)

  if (!butlerContext) throw new Error('ButlerContext has to be used within <ButlerContext.Provider>')

  return butlerContext
}
